var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5326_986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9 49.8C38.6519 49.8 49.8 38.6519 49.8 24.9C49.8 11.1481 38.6519 0 24.9 0C11.1481 0 0 11.1481 0 24.9C0 38.6519 11.1481 49.8 24.9 49.8Z",
    fill: "#3BA7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2991 37.0981H24.1991V33.3981C22.1991 33.1981 20.5991 32.4981 19.3991 31.0981C17.0991 28.5981 16.6991 24.3981 16.9991 21.5981C16.9991 21.0981 17.4991 20.7981 17.8991 20.8981C18.3991 20.8981 18.6991 21.3981 18.5991 21.7981C18.2991 24.1981 18.6991 27.8981 20.5991 29.9981C21.6991 31.1981 23.1991 31.7981 24.9991 31.7981H25.8991V35.4981H28.3991C28.8991 35.4981 29.1991 35.8981 29.1991 36.2981C29.1991 36.6981 28.7991 37.0981 28.2991 37.0981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9996 37.0984H21.8996C21.3996 37.0984 21.0996 36.6984 21.0996 36.2984C21.0996 35.7984 21.4996 35.4984 21.8996 35.4984H24.3996V31.7984H25.1996C27.0996 31.7984 28.4996 31.1984 29.5996 29.9984C31.4996 27.8984 31.8996 24.1984 31.5996 21.7984C31.5996 21.2984 31.8996 20.8984 32.2996 20.8984C32.6996 20.7984 33.1996 21.1984 33.1996 21.5984C33.4996 24.3984 33.0996 28.4984 30.7996 31.0984C29.5996 32.4984 27.8996 33.2984 25.9996 33.3984V37.0984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9988 30C22.3988 30 20.2988 27.9 20.2988 25.3V16.7C20.2988 14.1 22.3988 12 24.9988 12C27.5988 12 29.6988 14.1 29.6988 16.7V25.3C29.6988 27.9 27.5988 30 24.9988 30ZM24.9988 13.6C23.2988 13.6 21.8988 15 21.8988 16.7V25.3C21.8988 27 23.2988 28.4 24.9988 28.4C26.6988 28.4 28.0988 27 28.0988 25.3V16.7C28.0988 15 26.6988 13.6 24.9988 13.6Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5326_986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.8,
    height: 49.8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioIcon);
export default __webpack_public_path__ + "static/media/audioIcon.d59a424aee657af5d3457b60d0b25c8e.svg";
export { ForwardRef as ReactComponent };